module.exports = __webpack_public_path__ + "static/img/83-1.3bf7099.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/83-1.jpg
// module id = u13e
// module chunks = 0